import React from 'react';
import {
    NavLink,
  } from 'react-router-dom';
  
const SmallScreenMenu = (props) => {
  const {menuOpen, setMenuOpen} = props;
  const handleClick = () => {
    setMenuOpen(!menuOpen);
  }
    return (
      <div onClick={handleClick} className="open-menu col">
        <NavLink to='/'>Home</NavLink>
        <NavLink to='/flooring'>Flooring</NavLink>
        <NavLink to='/painting'>Painting</NavLink>
        <NavLink to='/remodeling'>Remodeling</NavLink>
        {/* <NavLink to='/pricing'>Pricing</NavLink> */}
      </div>
    );
  }
  
  export default SmallScreenMenu;
  